export default __webpack_public_path__ + "static/media/az.302b01b5.svg";